export default "__VITE_ASSET__C$A$g8_x__"